export default __webpack_public_path__ + "static/media/640_business02-fr-web.57a3dc26.png";